import React, { useState, useEffect, useMemo } from "react";
import moment from 'moment';
import styled from 'styled-components';
import SessionCard from '../../SessionCard/SessionCard';

const SessionDayBlock = styled.div`
  background: ${props => props.$selected ? '#F3FBFF' : '#ffffff'};
  color: ${props => props.$selected ? '#0280c6' : '#565656'};
  padding: 10px 30px;
  border: ${props => props.$selected ? '1px solid #0280c6' : '1px solid #c4c4c4'};
  border-radius: 5px;
  font-size: 16px;
  word-wrap: break-word;
  cursor: pointer;
`;

export default ({
  sessions = []
}) => {

    const [displayFilters, setDisplayFilters] = useState({})

    const sessionDays = useMemo(() => {
      const uniqueDates = []
      sessions.forEach(({ date }) => {
        if (uniqueDates.indexOf(date) < 0) {
          uniqueDates.push(date);
        }
      })
      return uniqueDates
        .map((date) => moment(date, 'YYYY-MM-DD'))
        .sort((a, b) => a - b)
    }, [sessions]);
  
    useEffect(() => {
      if (sessionDays[0]) {
        setDisplayFilters({
          date: sessionDays[0].format('YYYY-MM-DD')
        })
      }
    }, [sessionDays])

    const onSessionDaySelected = (sessionDay) => {
      setDisplayFilters({
        date: sessionDay.format('YYYY-MM-DD')
      })
    }

    const filteredSessions = sessions.filter(({ 
      date = '', 
    }) => {
      let passedFilters = true;
  
      const dateFilter = displayFilters.date;
  
      if (dateFilter && dateFilter !== date) {
        passedFilters = false;
      }
  
      return passedFilters;
    })

  return (
    <div>
      <div style={{
        display: 'flex',
        marginBottom: '20px',
        columnGap: '20px',
        rowGap: '20px',
      }}>
        {
          sessionDays.map((sessionDay, index) => {
            const displayDate = sessionDay.format('ddd, MM/DD/YY');
            const isSelected = displayFilters.date === sessionDay.format('YYYY-MM-DD');
            return (
              <SessionDayBlock
                key={displayDate}
                $selected={isSelected}
                onClick={() => onSessionDaySelected(sessionDay)}
              >
                <div style={{ color: isSelected ? '#222222' : '#565656' }}>{`Day ${index + 1}`}</div>
                <div style={{ fontWeight: 'bold', marginTop: '10px' }}>{displayDate}</div>
              </SessionDayBlock>
            )
          })
        }
      </div>
      <div style={{
        flex: 1,
        display: 'flex',
        columnGap: '20px',
        rowGap: '20px',
        // padding: '20px',
        flexWrap: 'wrap'
      }}>
        {
          sessions.length > 0
            ?
            filteredSessions
              .sort(({ startTime: startTimeA }, { startTime: startTimeB }) => moment(startTimeA, 'hh:mm:ss') - moment(startTimeB, 'hh:mm:ss'))
              .map((session, index) => <SessionCard key={`${session.name}-${index}`} sessionData={session} suppressDetailButton={true} />)
            :
            <div style={{
              color: '#565656',
              fontSize: '14px',
            }}>
              {'No schedule created yet'}
            </div>
        }
      </div>
    </div>
  )
}